const o = (e = 0) => new Promise((t) => setTimeout(t, e));
export {
  o as t
};
